﻿import { Essentials, Autoformat, Heading, Paragraph, PasteFromOffice, SourceEditing, GeneralHtmlSupport, BlockQuote, HorizontalLine } from 'ckeditor5';
import { Bold, Italic, Subscript, Superscript, Strikethrough, Underline, RemoveFormat } from 'ckeditor5';
import { Image, ImageCaption, ImageStyle, ImageToolbar, ImageResize } from 'ckeditor5';
import { List, ListProperties, Table, TableToolbar, TableProperties, TableCellProperties } from 'ckeditor5';
import { FontBackgroundColor, FontFamily, FontSize, FontColor } from 'ckeditor5';
import { Alignment, Style, StyleEditing } from 'ckeditor5';
import { Link, LinkImage, LinkEditing, ContextualBalloon } from 'ckeditor5';
import { SpecialCharacters, SpecialCharactersArrows, SpecialCharactersCurrency, SpecialCharactersEssentials, SpecialCharactersLatin, SpecialCharactersMathematical, SpecialCharactersText } from 'ckeditor5';
import { WordCount } from 'ckeditor5';
import { Indent, IndentBlock } from 'ckeditor5';
import { LineHeight } from '@rickx/ckeditor5-line-height';

import { PasteFromOfficeEnhanced, FormatPainter } from 'ckeditor5-premium-features';

import customPlugins from './Plugins/index.js';

// Plugins to include in the build.
const builtinPlugins = [
	Essentials, Autoformat,
    SourceEditing,
	Bold, Italic, Strikethrough, Underline, RemoveFormat,
    Subscript, Superscript,
    FontBackgroundColor, FontFamily, FontSize, FontColor,
	BlockQuote, HorizontalLine,
	Heading,
	Image, ImageCaption, ImageStyle,  ImageToolbar, ImageResize,
	Link, LinkImage, LinkEditing, ContextualBalloon,
	List, ListProperties,
	Paragraph,
	PasteFromOffice, PasteFromOfficeEnhanced,
	FormatPainter,
	Table, TableToolbar, TableProperties, TableCellProperties,
	Alignment,
    Subscript,
    Superscript,
    Style, StyleEditing, GeneralHtmlSupport,
    SpecialCharacters, SpecialCharactersArrows, SpecialCharactersCurrency, SpecialCharactersEssentials, SpecialCharactersLatin, SpecialCharactersMathematical, SpecialCharactersText,
	WordCount,
	Indent, IndentBlock,
	LineHeight
];

export default [
	...builtinPlugins,
	...customPlugins
];